/**
 * Theme-aware color functions for dynamic styling.
 * Use these when you need inline style={{ color }} or style={{ backgroundColor }}
 * that must adapt to dark/light mode.
 */

export function scoreColor(score: number, isDark: boolean = false): string {
  if (score >= 80) return isDark ? '#34d399' : '#059669';  // emerald
  if (score >= 60) return isDark ? '#818cf8' : '#4f46e5';  // indigo (was blue)
  if (score >= 40) return isDark ? '#fbbf24' : '#d97706';  // amber
  return isDark ? '#f87171' : '#dc2626';                    // red
}

export function categoryColor(category: string, isDark: boolean = false): string {
  const colors: Record<string, [string, string]> = {
    // [light, dark]
    'technology': ['#4f46e5', '#818cf8'],
    'leadership': ['#7c3aed', '#a78bfa'],
    'strategy': ['#059669', '#34d399'],
    'finance': ['#d97706', '#fbbf24'],
    'operations': ['#0891b2', '#22d3ee'],
    'marketing': ['#e11d48', '#fb7185'],
    'analytics': ['#2563eb', '#60a5fa'],
    'product': ['#7c3aed', '#a78bfa'],
    'engineering': ['#4f46e5', '#818cf8'],
    'design': ['#ec4899', '#f472b6'],
    'sales': ['#ea580c', '#fb923c'],
    'hr': ['#0d9488', '#2dd4bf'],
  };

  const key = category.toLowerCase();
  const match = colors[key];
  if (match) return isDark ? match[1] : match[0];

  // Fallback: hash-based color for unknown categories
  return isDark ? '#94a3b8' : '#64748b';
}

/**
 * Returns Tailwind class string for score-based coloring (no inline styles needed).
 */
export function scoreColorClass(score: number): string {
  if (score >= 80) return 'text-success-600 dark:text-success-400';
  if (score >= 60) return 'text-primary-600 dark:text-primary-400';
  if (score >= 40) return 'text-warning-600 dark:text-warning-400';
  return 'text-error-600 dark:text-error-400';
}

export function scoreBgClass(score: number): string {
  if (score >= 80) return 'bg-success-100 dark:bg-success-500/10 text-success-800 dark:text-success-400';
  if (score >= 60) return 'bg-primary-100 dark:bg-primary-500/10 text-primary-800 dark:text-primary-400';
  if (score >= 40) return 'bg-warning-100 dark:bg-warning-500/10 text-warning-800 dark:text-warning-400';
  return 'bg-error-100 dark:bg-error-500/10 text-error-800 dark:text-error-400';
}
